import {
	ADD_REPORT_SUCCESS,
	ADD_REPORT_FAIL,
	GET_REPORT_SUCCESS,
	GET_REPORT_FAIL,
	GET_REPORTS_SUCCESS,
	GET_REPORTS_FAIL,
	UPDATE_REPORT_SUCCESS,
	UPDATE_REPORT_FAIL,
	DELETE_REPORT_SUCCESS,
	DELETE_REPORT_FAIL,
	SET_REPORT_LOADING,
	CLEAR_REPORT_ERROR,
} from '../reducers/types';
import axios from 'axios';

import { returnError, tokenConfig } from './actionHelperFunc';
const reportUrl = '/api/report';

// USER RELATED ACTIONS
export const addReport = (newReport) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REPORT_ERROR });
		dispatch({ type: SET_REPORT_LOADING });

		const { data } = await axios.post(`${reportUrl}/addReport`, newReport, tokenConfig(getState));

		dispatch({
			type: ADD_REPORT_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		dispatch({ type: ADD_REPORT_FAIL, payload: returnError(error) });
	}
};

export const getReportById = (reportId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REPORT_ERROR });
		dispatch({ type: SET_REPORT_LOADING });

		const { data } = await axios.get(`${reportUrl}/getById?reportId=${reportId}`, tokenConfig(getState));
		dispatch({
			type: GET_REPORT_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		dispatch({ type: GET_REPORT_FAIL, payload: returnError(error) });
	}
};

export const getAllReportsByProject = (projectId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REPORT_ERROR });
		dispatch({ type: SET_REPORT_LOADING });

		const { data } = await axios.get(`${reportUrl}/projectDashboard?projectId=${projectId}`, tokenConfig(getState));

		dispatch({
			type: GET_REPORTS_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		dispatch({ type: GET_REPORTS_FAIL, payload: returnError(error) });
	}
};

export const updateReport = (report) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REPORT_ERROR });
		dispatch({ type: SET_REPORT_LOADING });

		const config = tokenConfig(getState);

		const { data } = await axios.post(`${reportUrl}/editReport`, report, config);
		dispatch({ type: UPDATE_REPORT_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: UPDATE_REPORT_FAIL, payload: returnError(error) });
	}
};

export const deleteReport = (reportId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REPORT_ERROR });
		dispatch({ type: SET_REPORT_LOADING });

		const config = tokenConfig(getState);

		const { data } = await axios.delete(`${reportUrl}/delete/${reportId}`, config);
		dispatch({ type: DELETE_REPORT_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: DELETE_REPORT_FAIL, payload: returnError(error) });
	}
};
